import { render } from "./PhoneInput1.vue?vue&type=template&id=4bc51ba4&scoped=true"
import script from "./PhoneInput1.vue?vue&type=script&lang=js"
export * from "./PhoneInput1.vue?vue&type=script&lang=js"

import "./PhoneInput1.vue?vue&type=style&index=0&id=4bc51ba4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc51ba4"]])

export default __exports__